<template>
	<div>
		<!--<navbar></navbar>-->
		<router-view />
	</div>
</template>
<script>
	//import Navbar from '@/components/Navbar.vue'
	import store from '../store';

	const beforeRouter = async (to, from, next) => {
		await store.dispatch('reset', to.params.projectSchema);
		await store.dispatch('setCurrentProject', to.params.projectSchema);
		await store.dispatch('fetchCatalogsAsync', to.params.projectSchema);
		await store.dispatch('fetchIsogdSections', to.params.projectSchema);
		next();
	}
	export default {
		components: {
			//Navbar
		},
		async beforeRouteEnter(to, from, next) {
			await beforeRouter(to, from, next);

		},
		async beforeRouteUpdate(to, from, next) {
			await beforeRouter(to, from, next);
		},
	}
</script>

